<div class="container-fluid cw-background manage-view">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-4 col-lg-offset-4 mb-5">
      <mat-card class="mat-elevation-z8 mt-5 pb-5" id="card">
        <div class="text-left go-back d-block">
          <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
        </div>
        <h6 class="text-center card-title-page mb-4">Edit Internal Provider:</h6>
        <div class="row d-flex justify-content-center">
          <button
            *ngIf="currentUser.hasRight(['admin']) && currentUser.isGlobal()"
            (click)="toggleManageConfig()"
            class="edit"
            color="primary"
            mat-icon-button
          >
            <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
          </button>
          <div class="col-12 col-sm-9 col-sm-offset-1">
            <app-dynamic-form
              *ngIf="questions"
              [questions]="questions"
              [disabled]="!isEdit"
              (formSubmit)="onSubmit($event)"
            >
            </app-dynamic-form>
          </div>
        </div>
        <div class="form-group-button text-center mt-4">
          <button
            *ngIf="currentUser.hasRight(['admin']) && currentUser.isGlobal()"
            (click)="deleteConfigModal()"
            disableRipple
            mat-button
            class="delete"
          >
            <mat-icon matPreffix>delete</mat-icon>
            Delete Internal Provider
          </button>
        </div>
      </mat-card>
    </div>
  </div>
</div>
